import { CircularProgress, Grid } from '@mui/material';

import { useFormikContext, FieldArray } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { useJobmarketFacultiesQuery } from 'api/hooks/useJobmarketFacultiesQuery';
import FacultyBox from 'app/containers/Jobmarket/CompanyDetail/components/FacultyBox';
import { translations } from 'locales/i18n';

import { AlertActions } from '../../Alert/slice';

export default function FacultyData() {
  const { errors, touched }: any = useFormikContext<any>();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: faculties, isError, isLoading } = useJobmarketFacultiesQuery();

  useEffect(() => {
    if (isError) {
      dispatch(AlertActions.error(`${t(translations.pages.login.alerts.errorLoading())}`));
      navigate('/', { replace: true });
    }
  }, [dispatch, isError, navigate, t]);

  if (!faculties || isLoading) {
    return <CircularProgress />;
  }

  const sortedFaculties = [...faculties];
  sortedFaculties.sort((a, b) => {
    if (a.courses.length < b.courses.length) return 1;
    if (a.courses.length > b.courses.length) return -1;
    return 0;
  });

  return (
    <>
      <Grid container className="register-form__description">
        {t(translations.pages.login.formDescriptions.facultyData())}
      </Grid>
      {touched.courses && errors.courses && (
        <Grid container style={{ color: 'red' }}>
          {errors.courses}
        </Grid>
      )}
      <Grid container className="register-form__faculties">
        <FieldArray name="courses">
          {({ form, ...helpers }) =>
            sortedFaculties.map(f => (
              <FacultyBox
                dense
                editMode
                key={f.id}
                faculty={f}
                selectedCourses={form.values.courses}
                arrayHelpers={helpers}
              />
            ))
          }
        </FieldArray>
      </Grid>
    </>
  );
}
